<template>
  <div class="productName">
    <vxe-grid
      border
      show-overflow
      resizable
      ref="productName"
      class="vxe-table-element"
      size="mini"
      align="left"
      :auto-resize="true"
      :data="tableData"
      :columns="columnList"
    >
    </vxe-grid>
    <!-- 分页 -->
    <div class="pagination">
      <el-pagination
        ref="page"
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page.pageNum"
        :page-sizes="[10, 20, 50, 100]"
        :page-count="page.pages"
        :page-size="page.pageSize"
        :total="page.total"
        layout="total, sizes, prev, pager, next, jumper"
      ></el-pagination>
    </div>
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  import API from '@/api/productCenter/prescriptionData';

  export default {
    name: 'prductNameQuery',
    props: ['formulaNo'],
    computed: {
      ...mapState({
        dictListMap: (state) => state.dict.dictListMap,
      }),
      columnList() {
        return [
          { type: 'seq', width: 60, title: this.$t('table.index') }, // 序号
          { field: 'productCode', title: this.$t('prescriptionList.label.productCode') },
          { field: 'productName', title: this.$t('prescriptionList.label.productName') },
        ];
      },
    },
    data() {
      return {
        tableData: [],
        page: {
          pages: 0,
          pageSize: 10,
          pageNum: 1,
          total: 0,
        },
      };
    },
    methods: {
      getData() {
        this.load = true;
        const { pageNum, pageSize } = this.page;
        let params = Object.assign({ formulaNo: this.formulaNo }, { pageNum, pageSize });
        this.$axios.post(API.QUERY_ALL_PRODUCT, params).then((res) => {
          this.load = false;
          if (0 == res.data.code) {
            this.tableData = res.data.data.records;
            this.page.total = res.data.data.total;
          } else {
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: 'error',
            });
          }
        });
      },
      // 重置
      resetBtnClick() {
        this.page.pages = 0;
        this.page.pageSize = 10;
        this.page.pageNum = 1;
        this.page.total = 0;
        this.getData();
      },
      handleSizeChange(value) {
        this.page.pageSize = value;
        this.getData();
      },
      handleCurrentChange(value) {
        this.page.pageNum = value;
        this.getData();
      },
      formatterStatus({ cellValue }) {
        return this.getDictValue(cellValue, 'contract_status');
      },
      getDictValue(cellValue, type) {
        let list = this.dictListMap[type];
        const item = list.find((item) => item.value === cellValue);
        return item ? item.label : '';
      },

      exportChildData() {
        return this.$refs.productName.getTableData().fullData;
      },
    },
  };
</script>
